import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Dbindices } from '../../../../../../../core/entities/dbindices.model';
import { Xmlfields } from '../../../../../../../core/entities/xmlfields.model';
import { Dbindexflds } from '../../../../../../../core/entities/dbindexflds.model';
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';
import * as _ from 'lodash';

@Injectable()
export class ViewDialogsDbindicesService {

  loading: boolean = true;
  dbindices: Dbindices = new Dbindices();
  originaldbindices: Dbindices = new Dbindices();
  xmlfields: Xmlfields[] = [];

  selectDbindexfld: Dbindexflds[] = new Array<Dbindexflds>();
  dbindexflds: Dbindexflds[] = new Array<Dbindexflds>();

  constructor(private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.dbindices = data.dbindice;
    this.originaldbindices = _.cloneDeep(this.dbindices);
    console.log(data);

    return forkJoin([this.internalHomeService.allDbindexflds(),
                    this.internalHomeService.getbyIdXmlfields(this.dbindices.dbmodelId.xmldefId.id)])
      .pipe(map(dataGroup => {
        this.dbindexflds = dataGroup[0];
        this.xmlfields = dataGroup[1];

        for (let i = 0; i < this.dbindexflds.length; i++) {
          if (this.dbindices.id === this.dbindexflds[i].dbindexId.id)
            this.selectDbindexfld.push(this.dbindexflds[i]);
        }

        return true;
      }));
  }

  build() {
    this.selectDbindexfld = new Array<Dbindexflds>();
  }

}
